import { render, staticRenderFns } from "./ComprehensiveInformationQuery.vue?vue&type=template&id=043f8dfa&scoped=true"
import script from "./ComprehensiveInformationQuery.vue?vue&type=script&lang=js"
export * from "./ComprehensiveInformationQuery.vue?vue&type=script&lang=js"
import style0 from "./ComprehensiveInformationQuery.vue?vue&type=style&index=0&id=043f8dfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043f8dfa",
  null
  
)

export default component.exports